import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { Container } from "reactstrap";

import logoDark from "../assets/images/logo-dark.png";

import VerticalLayout from "./VerticalLayouts";
import TwoColumnLayout from "./TwoColumnLayout";
import HorizontalLayout from "./HorizontalLayout";

const Sidebar = ({ layoutType }) => {

  // ==========================================
  // CLOSE SIDEBAR
  // ==========================================

  const closeSidebar = () => {
    document.body.classList.remove(
      "vertical-sidebar-enable"
    );
  };

  // ==========================================
  // OVERLAY
  // ==========================================

  useEffect(() => {

    const overlay =
      document.querySelector(".vertical-overlay");

    if (!overlay) {
      return;
    }

    const handleOverlayClick = () => {
      closeSidebar();
    };

    overlay.addEventListener(
      "click",
      handleOverlayClick
    );

    return () => {
      overlay.removeEventListener(
        "click",
        handleOverlayClick
      );
    };

  }, []);

  // ==========================================
  // CLOSE SIDEBAR AFTER NAVIGATION
  // ==========================================

  useEffect(() => {

    const handleMenuClick = (event) => {

      const link =
        event.target.closest(
          ".app-menu a"
        );

      if (!link) {
        return;
      }

      setTimeout(() => {
        closeSidebar();
      }, 100);

    };

    document.addEventListener(
      "click",
      handleMenuClick
    );

    return () => {
      document.removeEventListener(
        "click",
        handleMenuClick
      );
    };

  }, []);

  // ==========================================
  // DESKTOP HOVER SIDEBAR
  // ==========================================

  const addEventListenerOnSmHoverMenu = () => {

    const sidebarSize =
      document.documentElement.getAttribute(
        "data-sidebar-size"
      );

    if (sidebarSize === "sm-hover") {

      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover-active"
      );

    } else {

      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover"
      );

    }
  };

  return (
    <React.Fragment>

      {/* =====================================
                SIDEBAR
            ====================================== */}

      <div className="app-menu navbar-menu">

        {/* =================================
                    SINGLE LOGO
                ================================== */}

        <div className="navbar-brand-box">

          <Link
            to="/dashboard"
            className="portal-sidebar-logo"
            onClick={closeSidebar}
          >

            <img
              src={logoDark}
              alt="CRM Expert"
            />

          </Link>

          {/* Desktop sidebar collapse */}
          <button
            onClick={
              addEventListenerOnSmHoverMenu
            }
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>

        </div>

        {/* =================================
                    HORIZONTAL LAYOUT
                ================================== */}

        {layoutType === "horizontal" ? (

          <div id="scrollbar">

            <Container fluid>

              <div id="two-column-menu"></div>

              <ul
                className="navbar-nav"
                id="navbar-nav"
              >
                <HorizontalLayout />
              </ul>

            </Container>

          </div>

        ) : layoutType === "twocolumn" ? (

          /* ==============================
             TWO COLUMN
          =============================== */

          <React.Fragment>

            <TwoColumnLayout
              layoutType={layoutType}
            />

            <div className="sidebar-background"></div>

          </React.Fragment>

        ) : (

          /* ==============================
             VERTICAL
          =============================== */

          <React.Fragment>

            <SimpleBar
              id="scrollbar"
              className="h-100"
            >

              <Container fluid>

                <div id="two-column-menu"></div>

                <ul
                  className="navbar-nav"
                  id="navbar-nav"
                >

                  <VerticalLayout
                    layoutType={
                      layoutType
                    }
                  />

                </ul>

              </Container>

            </SimpleBar>

            <div className="sidebar-background"></div>

          </React.Fragment>
        )}

      </div>

      {/* =====================================
                MOBILE OVERLAY
            ====================================== */}

      <div className="vertical-overlay"></div>

    </React.Fragment>
  );
};

export default Sidebar;